<template>
  <div class="main-toolbar">
    <!-- <router-link
      v-if="isAdmin"
      :to="{ name: 'postAdd'}"
      class="no-link"
    >
      <v-icon>add</v-icon>
    </router-link> -->
    <invite-friend-menu v-if="isInviter || isAdmin"></invite-friend-menu>
    <notifications-menu v-if="isMember"></notifications-menu>
    <!-- <img v-if="auth.photoURL" :src="auth.photoURL" class="avatar" /> -->
    <main-menu></main-menu>
  </div>
</template>

<script>

import InviteFriendMenu from '@/containers/InviteFriendMenu';
import NotificationsMenu from '@/containers/NotificationsMenu';
import MainMenu from '@/containers/MainMenu';

export default {
  name: 'main-toolbar',
  components: {
    InviteFriendMenu,
    NotificationsMenu,
    MainMenu,
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isMember() {
      return this.$store.getters.isMember;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isInviter() {
      return this.$store.getters.isInviter;
    },
  },
};

</script>

<style>

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

</style>



// WEBPACK FOOTER //
// src/containers/MainToolbar.vue